import { checkNoChosenYears } from 'portfolio3/features/pdf/utils/checkNoChosenYears';
import { checkSectionEmptiness } from 'portfolio3/features/pdf/utils/checkSectionEmptiness';
import { sortPeriods } from 'portfolio3/features/pdf/utils/sortPeriods';
import { createSelector } from 'reselect';
import { chosenYearsSelector } from 'selectors/drawers';
import { academicYearsTouchedSelector } from 'selectors/drawers/linkSharingDrawer';

import { sportClubsYearsSelector } from './sportClubsYearsSelector';
import { sportCompetitionsYearsSelector } from './sportCompetitionsYearsSelector';
import { sportExpeditionsYearsSelector } from './sportExpeditionsYearsSelector';
import { sportOccupationsYearsSelector } from './sportOccupationsYearsSelector';
import { sportRewardsYearsSelector } from './sportRewardsYearsSelector';

export const sportSectionAcademicYearsDataSelector = createSelector(
  [
    // Данные раздела Спорт
    sportRewardsYearsSelector,
    sportClubsYearsSelector,
    sportOccupationsYearsSelector,
    sportCompetitionsYearsSelector,
    sportExpeditionsYearsSelector,
    // Выбранные года
    chosenYearsSelector,
    academicYearsTouchedSelector,
  ],
  (
    sportRewardsYears,
    sportClubsYears,
    sportOccupationsYears,
    sportCompetitionsYears,
    sportExpeditionsYears,
    chosenYears,
    academicYearsTouched,
  ) => {
    const emptyDataMap = {
      sportReward: checkNoChosenYears(sportRewardsYears, chosenYears, academicYearsTouched),
      sportClub: checkNoChosenYears(sportClubsYears, chosenYears, academicYearsTouched),
      sportUnit: checkNoChosenYears(sportOccupationsYears, chosenYears, academicYearsTouched),
      sportGames: checkNoChosenYears(sportCompetitionsYears, chosenYears, academicYearsTouched),
      hike: checkNoChosenYears(sportExpeditionsYears, chosenYears, academicYearsTouched),
    };

    const periods: Set<string> = new Set([
      ...sportRewardsYears,
      ...sportClubsYears,
      ...sportOccupationsYears,
      ...sportCompetitionsYears,
    ]);

    return {
      academicYears: sortPeriods(periods),
      emptyDataMap: {
        ...emptyDataMap,
        sport: checkSectionEmptiness(emptyDataMap),
      },
    };
  },
);
